import { WidgetDefinition } from '../models/WidgetDefinition';

export const FlowChartWidgetDefinition: WidgetDefinition = {
    baseType: 'FlowChart',
    group: 'Charts',
    hasImage: true,
    highlights: ['Identifiers properties and values over an image background'],
    icon: 'fa-map',
    sortingOrder: 1000,
    title: 'Image',
    type: 'FlowChart'
};